/* eslint-disable react/prop-types */
import React from 'react';
import { Input, Select, Divider } from 'antd';
import PropTypes from 'prop-types';
import { SearchOutlined } from '@ant-design/icons';
import cn from 'classnames';
import classes from './Search.module.scss';
import debounce from 'lodash/debounce';

const SearchInput = (props) => {
  const {
    prefix,
    enterButton,
    value,
    searchByOption,
    placeholder,
    onSearch,
    searchByOptions,
    onChange,
    onChangeSearchByOption,
    hideSearchBy,
    className,
    debounceTime = 0,
  } = props;
  const [keyword, setKeyword] = React.useState(value);
  const [searchBy, setSearchBy] = React.useState(searchByOption);

  const debouncedOnSearchChange = React.useMemo(() => {
    return debounce((searchValue) => {
      if (onChange) {
        onChange(searchValue);
      }
    }, debounceTime);
  }, [debounceTime]);

  const onSearchChange = (e) => {
    setKeyword(e.target.value);
    debouncedOnSearchChange(e.target.value);
  };

  const onSearchByOptionChange = (option) => {
    setSearchBy(option);
    if (onChangeSearchByOption) {
      onChangeSearchByOption(option);
    }
  };

  const handleSearch = (searchValue) => {
    if (onSearch) {
      onSearch(searchValue, searchBy);
    }
  };

  const suffix = React.useMemo(() => {
    if (Array.isArray(searchByOptions)) {
      return (
        <>
          <Divider type="vertical" />
          <Select
            popupMatchSelectWidth={150}
            bordered={false}
            options={searchByOptions.map((option) => ({
              ...option,
              className: classes.searchByOption,
            }))}
            value={searchBy}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            onClick={(e) => e.stopPropagation()}
            onChange={onSearchByOptionChange}
          />
        </>
      );
    }
    return undefined;
  }, [searchByOptions, searchBy]);

  return (
    <Input.Search
      allowClear
      className={cn(classes.searchInput, className, {
        [classes.withoutEnterButton]: enterButton === null,
      })}
      placeholder={typeof placeholder === 'function' ? placeholder(searchBy) : placeholder}
      prefix={prefix}
      enterButton={enterButton}
      value={keyword}
      onSearch={handleSearch}
      onChange={onSearchChange}
      suffix={hideSearchBy ? undefined : suffix}
    />
  );
};

SearchInput.propTypes = {
  enterButton: PropTypes.node,
  prefix: PropTypes.node,
  value: PropTypes.string,
  onSearch: PropTypes.func,
  onChange: PropTypes.func,
  onChangeSearchByOption: PropTypes.func,
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  ]),
  searchByOption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  ]),
  searchByOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

SearchInput.defaultProps = {
  enterButton: 'Search',
  placeholder: 'Search',
  prefix: <SearchOutlined />,
  value: '',
  searchByOption: undefined,
  onSearch: undefined,
  onChange: undefined,
  searchByOptions: undefined,
  onChangeSearchByOption: undefined,
};

export default SearchInput;
